import { render, staticRenderFns } from "./CarDamage.vue?vue&type=template&id=216cc365"
import script from "./CarDamage.vue?vue&type=script&lang=js"
export * from "./CarDamage.vue?vue&type=script&lang=js"
import style0 from "./CarDamage.vue?vue&type=style&index=0&id=216cc365&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports